import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';

const Add = () => {
  const [formData, setFormData] = useState({
    name: '',
    image: null,
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, type } = e.target;
    const value = type === 'file' ? e.target.files[0] : e.target.value;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('image', formData.image);

    try {
      const response = await postRequest('galleries', formDataToSend, {

        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response?.status === 200 || response?.status === 201) {
        toast.success('Gallery added successfully!');
        navigate('/gallery');
        setFormData({ name: '', image: null });
      } else {
        toast.error('Something went wrong!');
      }
    } catch (error) {
      console.error('Error adding gallery:', error);
      toast.error('Failed to add Benner. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Benner</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row mx-4">
          <div className="col-sm-12 mt-2">
            <label htmlFor="galleryTitle" className="adminlables">Title</label>
            <input
              type="text"
              id="galleryTitle"
              name="name"
              value={formData.name}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-sm-12 mt-4">
            <label htmlFor="galleryImage" className="adminlables">Image</label>
            <input
              type="file"
              id="galleryImage"
              name="image"
              className="form-control btn-block filebg"
              onChange={handleChange}
              accept="image/*"
              required
            />
          </div>
        </div>
        <div className="mt-4 text-right mx-5">
          <button className="btn addbtn btn-lg" type="submit">Add Benner</button>
        </div>
      </form>
    </div>
  );
};

export default Add;
